import { Button, H5, H6 } from "@sellar-io/components";
import { PaymentMethodListResponseType } from "@sellar-io/api-v2/types";
import { ReactElement, useState } from "react";
import { Icon } from "../../../components";
import amexSvg from "../../../images/amex.svg";
import mastercardSvg from "../../../images/mastercard.svg";
import visaSvg from "../../../images/visa.svg";
import { capitalize } from "../../../utils/nativeLodash";
import { PaymentMethodDeleteDialog } from "./Dialogs/PaymentMethodDeleteDialog";

const getCardImage = (brand: string) => {
  switch (brand) {
    case "amex": {
      return amexSvg;
    }
    case "mastercard": {
      return mastercardSvg;
    }
    default: {
      return visaSvg;
    }
  }
};
export function PaymentMethodListItem({
  paymentMethod,
}: {
  paymentMethod: PaymentMethodListResponseType[number];
}): ReactElement {
  const [paymentMethodDeleteDialogActive, setPaymentMethodDeleteDialogActive] =
    useState<boolean>(false);
  return (
    <>
      <div className={"flex flex-row items-center justify-between"}>
        <div className="flex flex-row gap-2">
          <img
            className={"h-[25px] self-start"}
            src={getCardImage(paymentMethod.brand ?? "")}
          />
          <H5>
            {capitalize(paymentMethod.brand ?? "")}{" "}
            {capitalize(paymentMethod.funding ?? "")}
          </H5>
          <H6> Ending in {paymentMethod.last4}</H6>
        </div>
        <div className="cursor-pointer">
          <Button
            color={"tertiary"}
            onClick={() => setPaymentMethodDeleteDialogActive(true)}
          >
            Manage <Icon icon={"CHEVRON_RIGHT"} />
          </Button>
        </div>
      </div>
      <PaymentMethodDeleteDialog
        brand={paymentMethod.brand}
        funding={paymentMethod.funding}
        active={paymentMethodDeleteDialogActive}
        onDismiss={() => setPaymentMethodDeleteDialogActive(false)}
        suppliers={paymentMethod.Suppliers}
      />
    </>
  );
}
